import script from "./LinkCell.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkCell.vue?vue&type=script&setup=true&lang=js"

import "./LinkCell.vue?vue&type=style&index=0&id=6ba38dc8&scoped=true&lang=css"
script.__scopeId = "data-v-6ba38dc8"

export default script